"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseView_1 = require("@/views/BaseView");
var vue_property_decorator_1 = require("vue-property-decorator");
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var SimilarFeaturedPartnership_vue_1 = __importDefault(require("@/components/trip/featured-partnership-gallery/similar/SimilarFeaturedPartnership.vue"));
var filters_1 = require("@/filter/filters");
var TimeLine_vue_1 = __importDefault(require("@/components/time-line/TimeLine.vue"));
var MapFeaturedTrip_vue_1 = __importDefault(require("@/components/maps/map-featured-trip/MapFeaturedTrip.vue"));
var ImagesGalleryExtended_vue_1 = __importDefault(require("@/components/images-gallery/extended/ImagesGalleryExtended.vue"));
vue_property_decorator_1.Component.registerHooks([
    'beforeRouteUpdate'
]);
var TripFeaturedPreview = /** @class */ (function (_super) {
    __extends(TripFeaturedPreview, _super);
    function TripFeaturedPreview() {
        var _this = _super.call(this) || this;
        _this.tripFeatured = null;
        _this.localities = null;
        _this.numberDays = null;
        _this.startPointOfInterest = null;
        _this.endPointOfInterest = null;
        _this.partnership = null;
        _this.loadingMap = false;
        _this.showMap = false;
        return _this;
    }
    TripFeaturedPreview.prototype.mounted = function () {
        this.loadPartnership();
        this.loadTripFeatured();
    };
    TripFeaturedPreview.prototype.loadPartnership = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.$getPartnershipDataService.request(this.$route.params.partnershipSlug)];
                    case 1:
                        _a.partnership = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TripFeaturedPreview.prototype.getHttpRequest = function () {
        switch (this.$route.name) {
            case 'tripFeaturedPreviewBySlug':
                return this.$getTripFeaturedBySlugService.request(this.$route.params.tripFeaturedSlug);
            case 'tripFeaturedPreviewById':
                return this.$getTripFeaturedByIdService.request(this.$route.params.tripFeaturedId);
        }
        new Error("Http request is undefined");
    };
    TripFeaturedPreview.prototype.loadTripFeatured = function () {
        var _this = this;
        this.loader = true;
        var httpRequest = this.getHttpRequest();
        httpRequest.then(function (response) {
            _this.tripFeatured = response;
            _this.updateNumberDays();
            if (_this.tripFeatured.route.route_points_of_interest.length) {
                _this.startPointOfInterest = _this.tripFeatured.route.route_points_of_interest[0].point_of_interest;
                if (_this.tripFeatured.route.route_points_of_interest.length > 1) {
                    _this.endPointOfInterest = _this.tripFeatured.route.route_points_of_interest[_this.tripFeatured.route.route_points_of_interest.length - 1].point_of_interest;
                }
                else {
                    _this.endPointOfInterest = _this.tripFeatured.route.route_points_of_interest[0].point_of_interest;
                }
            }
            _this.loader = false;
            _this.changeLanguageBySlug();
            _this.requestLocalities(response);
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripFeaturedPreview.prototype.requestLocalities = function (trip) {
        var _this = this;
        var _a, _b;
        if (((_a = this.partnership) === null || _a === void 0 ? void 0 : _a.slug) && trip) {
            this.$getPlanLocalitiesService.requestForFeaturedTrip({
                partnership_slug: (_b = this.partnership) === null || _b === void 0 ? void 0 : _b.slug,
                route: trip.route
            }).then(function (response) {
                trip.route = response.route;
                _this.tripFeatured = trip;
                _this.localities = response.localities;
            });
        }
    };
    TripFeaturedPreview.prototype.replicatePlan = function () {
        var _this = this;
        var _a, _b;
        if (((_a = this.partnership) === null || _a === void 0 ? void 0 : _a.slug) && this.tripFeatured) {
            var requestBody = {
                partnership_slug: (_b = this.partnership) === null || _b === void 0 ? void 0 : _b.slug,
                featured_plan: this.tripFeatured
            };
            this.$newPlanFromFeaturedService.request(requestBody).then(function (response) {
                var _a;
                console.log(response);
                if (((_a = response.alerts) === null || _a === void 0 ? void 0 : _a.problems) != null) {
                    return;
                }
                _this.$browserStorage.setPersistLevelSession(true).set('planner_response', response);
                _this.$browserStorage.setPersistLevelSession(true).set('planner_request', undefined);
                _this.$router.push({ name: 'tripPilgrimCreation' });
            });
        }
    };
    TripFeaturedPreview.prototype.updateNumberDays = function () {
        if (this.tripFeatured === null) {
            return;
        }
        var days = [];
        this.tripFeatured.route.route_points_of_interest.forEach(function (routePointOfInterest) {
            if (days.indexOf(routePointOfInterest.day) === -1) {
                days.push(routePointOfInterest.day);
            }
        });
        this.numberDays = days.length;
    };
    TripFeaturedPreview.prototype.beforeRouteUpdate = function (to, from, next) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, next()];
                    case 1:
                        _a.sent();
                        this.loadTripFeatured();
                        return [2 /*return*/];
                }
            });
        });
    };
    TripFeaturedPreview.prototype.changeLanguageBySlug = function () {
        var _this = this;
        var _a;
        if (!this.$route.params.pointOfInterestSlug) {
            return;
        }
        (_a = this.tripFeatured) === null || _a === void 0 ? void 0 : _a.translations.forEach(function (translation) {
            if (translation.slug === _this.$route.params.pointOfInterestSlug) {
                _this.$i18n.locale = translation.language.iso_639_1_code;
                if (_this.$route.params.languageIsoCode !== _this.$i18n.locale) {
                    _this.$router.replace({ name: _this.$route.name, params: { languageIsoCode: _this.$i18n.locale } });
                }
            }
        });
    };
    TripFeaturedPreview = __decorate([
        vue_property_decorator_1.Component({
            name: 'TripFeaturedPreview',
            components: {
                Spinner: Spinner_vue_1.default,
                ViewWrapper: ViewWrapper_vue_1.default,
                SimilarFeaturedPartnership: SimilarFeaturedPartnership_vue_1.default,
                TimeLine: TimeLine_vue_1.default,
                ImagesGalleryExtended: ImagesGalleryExtended_vue_1.default,
                MapFeaturedTrip: MapFeaturedTrip_vue_1.default
            },
            filters: {
                translation: filters_1.translation,
                getFirstImageUrl: filters_1.getFirstImageUrl
            },
            metaInfo: function () {
                var title = this.$t("title." + this.$route.name);
                var metaInfo = {
                    title: this.$t('title.default'),
                    titleTemplate: '%s | ' + title,
                    meta: [
                        { name: 'og:title', content: title },
                        { name: 'og:url', content: window.location.href }
                    ],
                    link: [
                        { rel: 'canonical', href: window.location.href }
                    ]
                };
                return metaInfo;
            }
        })
    ], TripFeaturedPreview);
    return TripFeaturedPreview;
}(BaseView_1.BaseView));
exports.default = TripFeaturedPreview;
